import { HeadingLevel } from '../../../components/core/Heading';
import { IntegrationCard } from './IntegrationCard';

type TogetherallCardProps = {
  headingLevel: HeadingLevel;
};

export const TogetherallCard = ({ headingLevel }: TogetherallCardProps): JSX.Element => {
  return (
    <IntegrationCard
      descriptionText="Connect with other college students in a safe, anonymous environment."
      headingLevel={headingLevel}
      headingText="Online Peer Support"
      linkText="Visit Togetherall"
      linkUrl="https://account.v2.togetherall.com/register/student"
      logoHeight={10}
      logoUrl="https://images.prismic.io/mantra-hub/0f779d20-cc0a-46ef-961d-ef093cfe4fff_Togetherall_Logo_Primary_Horizontal_RGB.png?auto=compress,format"
      serviceName="Togetherall"
    />
  );
};
